import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {getSearchParameters} from 'modules/sapiSearch/selectors'
import {pick} from 'ramda'

interface Props {
  /**
   * If `true`, will returns a stable object with props for suggestions.
   * Fixes a bug: when clicking a suggestion the main search changes, because the AP content is still rendered (while closing) this also kicks off a new suggestions search & bugs out the SRP
   * This locks suggestions props to 1 state for a particular AP view.
   *
   * This is not needed for desktop
   */
  stable?: boolean
}

const defaultParameters = {
  anchorHotelId: '',
  placeId: '',
  rooms: '',
  checkIn: '',
  checkOut: ''
}

export const useSuggestionsParameters = ({stable = true}: Props = {}) => {
  const currentSearch = useSelector(getSearchParameters)

  const suggestionsParameters = {
    anchorHotelId: currentSearch?.hotelId,
    ...pick(
      ['placeId', 'rooms', 'checkIn', 'checkOut'],
      currentSearch || defaultParameters
    )
  }

  const [cachedSuggestionsParameters, setCachedSuggestionsParameters] =
    useState(suggestionsParameters)

  useEffect(() => {
    if (stable || !currentSearch) return

    setCachedSuggestionsParameters({
      anchorHotelId: currentSearch.hotelId,
      ...pick(
        ['placeId', 'rooms', 'checkIn', 'checkOut'],
        currentSearch || defaultParameters
      )
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stable, currentSearch])

  return cachedSuggestionsParameters
}
